/**
 * @ngInject
 */
class BsTooltipBoundaryDirectiveController {
    constructor($element) {
        this.$element = $element;
    }
}
export function bsTooltipBoundaryDirective() {
    return {
        restrict: 'A',
        controller: BsTooltipBoundaryDirectiveController
    };
}
